import chart, {
  PLOTTYPE,
  TERM,
  TOOLS,
  CYCLE_ANALYSIS_TYPE,
  FIGURE,
  ADDON_CHART,
  SUB_CHART,
  // FIGURE_TYPE_OPTIONS,
  // FIGURE_GANN_FAN_OPTIONS,
  // FIGURE_FIBO_RETRACEMENT_AND_EXPANTION_OPTIONS,
  // FIGURE_FIBO_TIMEZONE_OPTIONS,
  FIGURE_COMMAND,
  FIGURE_OPTIONS_DEFAULT_SETTINGS,
  TechSetting,
  ADDON_CHART_DEFAULT_OPTIONS,
  SUB_CHART_DEFAULT_OPTIONS,
  ChartColor,
  PRICE_VOLUME_PARAM,
  CycleAnaTypesValue,
  TENKANTEN,
  MODAL_CANVAS_ID,
} from "components/atoms/chart/logic/chartConfig"
import chartColor from "components/atoms/chart/logic/chartColor"
import { UserStorage } from "utils/userStorage"
import { checkIsSp } from "utils/util"
import _ from "lodash"
import { TERM_EXTERNAL } from "components/pages/others/external/const"

interface chartPropatyBase {
  id: number
  displayTitle: string
  key: string
  icon?: string
  iconTransform?: string
}

export interface chartPropatyObj extends chartPropatyBase {
  visible?: boolean
  options?: Array<chartPropatyBase>
}

export interface chartSize {
  width?: number
  height?: number
  scaleWidth?: number
  scaleHeight?: number
}

export interface chartReducer {
  [id: string]: chartReducerPropety
}

export interface symbolDetail {
  Symbol: string
  SymbolName: string
  SymbolNameS: string
  PriceCompare: string
  PriceCompareText: string
  PriceTime: string
  Exchange: number
  SecurityType: number
  NumberOfDecimals: number
  Price: number
  LastClose: number
  ChangedRatio: number
  ChangedPrice: number
  Ticker: string
  LastCloseTime: string
  HighPrice: number
  HighPriceTime: string
  OpenPrice: number
  OpenPriceTime: string
  LowPrice: number
  LowPriceTime: string
}

export interface chartReducerPropety {
  providers: Array<any | null>
  symbol: object | {}
  symbolDetail: object | {}
  subSymbol?: Array<object | {}>
  subSymbolNode?: Array<object | {}>
  tools?: Array<chartPropatyObj | {}>
  figure?: chartPropatyObj | {}
  figureType?: chartPropatyObj | {}
  figureOptions?: Array<chartPropatyObj | {}>
  figureCommand?: chartPropatyObj | {}
  term: chartPropatyObj | {}
  span: object | {}
  plotType: object | {}
  cycleAnaTypes?: Array<chartPropatyObj | {}>
  addonChart?: Array<chartPropatyObj | {}>
  addonChartOptions?: object | {}
  addonSelected?: Array<number>
  subChart?: Array<chartPropatyObj | {}>
  subChartOptions?: object | {}
  subSelected?: Array<number>
  spred?: boolean
  size: chartSize
  renderCount: number
  tenkanKikan: number
  priceVolumeParam?: object
  chartInfoDialog?: Array<object | {}>
  priceVolumeValue?: object
  date?: Array<Date>
  relativeChartFlag?: boolean
  modalVisible?: boolean
  orderBookMode?: boolean
  industryMode?: boolean
}

export const pickTarget = ["displayTitle", "id", "key"]

/************************************
 * ACTION TYPE
 ************************************/
export const REDUX_CHART_INITIALIZE = "REDUX_CHART_INITIALIZE"
export const REDUX_CHART_COLOR_SETTING = "REDUX_CHART_COLOR_SETTING"
export const REDUX_CHART_SETTING = "REDUX_CHART_SETTING"
export const REDUX_CHART_DEFAULT_FIGURE_OPTIONS =
  "REDUX_CHART_DEFAULT_FIGURE_OPTIONS"
export const REDUX_CHART_CHANGE_PROVIDERS = "REDUX_CHART_CHANGE_PROVIDERS"
export const REDUX_CHART_CHANGE_SYMBOL = "REDUX_CHART_CHANGE_SYMBOL"
export const REDUX_CHART_CHANGE_SYMBOL_DETAIL =
  "REDUX_CHART_CHANGE_SYMBOL_DETAIL"
export const REDUX_CHART_CHANGE_SUB_SYMBOL = "REDUX_CHART_CHANGE_SUB_SYMBOL"
export const REDUX_CHART_CHANGE_SUB_SYMBOL_NODE =
  "REDUX_CHART_CHANGE_SYMBOL_NODE"
export const REDUX_CHART_CHANGE_TOOLS = "REDUX_CHART_CHANGE_TOOLS"
export const REDUX_CHART_CHANGE_FIGURE = "REDUX_CHART_CHANGE_FIGURE"
export const REDUX_CHART_CHANGE_FIGURES_ALL_CLEAR =
  "REDUX_CHART_CHANGE_FIGURES_ALL_CLEAR"
export const REDUX_CHART_CHANGE_FIGURE_COMMAND =
  "REDUX_CHART_CHANGE_FIGURE_COMMAND"
export const REDUX_CHART_CHANGE_FIGURE_TYPE = "REDUX_CHART_CHANGE_FIGURE_TYPE"
export const REDUX_CHART_CHANGE_FIGURE_OPTIONS =
  "REDUX_CHART_CHANGE_FIGURE_OPTIONS"
export const REDUX_CHART_CHANGE_TERM = "REDUX_CHART_CHANGE_TERM"
export const REDUX_CHART_CHANGE_ASHI_COUNT = "REDUX_CHART_CHANGE_ASHI_COUNT"
export const REDUX_CHART_CHANGE_SPAN = "REDUX_CHART_CHANGE_SPAN"
export const REDUX_CHART_CHANGE_PLOTTYPE = "REDUX_CHART_CHANGE_PLOTTYPE"
export const REDUX_CHART_CHANGE_CYCLE_ANALYSIS_TYPE =
  "REDUX_CHART_CHANGE_CYCLE_ANALYSIS_TYPE"
export const REDUX_CHART_CHANGE_ADDON_CHART = "REDUX_CHART_CHANGE_ADDON_CHART"
export const REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS =
  "REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS"
export const REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS_RESET =
  "REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS_RESET"
export const REDUX_CHART_CHANGE_SUB_CHART = "REDUX_CHART_CHANGE_SUB_CHART"
export const REDUX_CHART_CHANGE_SUB_CHART_OPTIONS =
  "REDUX_CHART_CHANGE_SUB_CHART_OPTIONS"
export const REDUX_CHART_CHANGE_SUB_CHART_OPTIONS_RESET =
  "REDUX_CHART_CHANGE_SUB_CHART_OPTIONS_RESET"
export const REDUX_CHART_CHANGE_SIZE = "REDUX_CHART_CHANGE_ADDON_SIZE"
export const REDUX_CHART_CHANGE_RENDER_COUNT = "REDUX_CHART_CHANGE_RENDER_COUNT"
export const REDUX_CHART_CHANGE_TENKANKIKAN = "REDUX_CHART_CHANGE_TENKANKIKAN"
export const REDUX_CHART_CHANGE_PRICE_VOLUME_PARAM =
  "REDUX_CHART_CHANGE_PRICE_VOLUME_PARAM"
export const REDUX_CHART_CHANGE_DIALOG = "REDUX_CHART_CHANGE_DIALOG"
export const REDUX_CHART_CHANGE_DIALOG_PRICE_VOLUME_VALUE =
  "REDUX_CHART_CHANGE_DIALOG_PRICE_VOLUME_VALUE"
export const REDUX_CHART_CHANGE_DATE = "REDUX_CHART_CHANGE_DATE"
export const REDUX_CHART_UNMOUNT = "REDUX_CHART_UNMOUNT"
export const REDUX_CHART_RELATIVE_CHART_FLAG = "REDUX_CHART_RELATIVE_CHART_FLAG"
export const REDUX_CHART_ADDON_SELECTED = "REDUX_CHART_ADDON_SELECTED"
export const REDUX_CHART_SUB_SELECTED = "REDUX_CHART_SUB_SELECTED"
export const REDUX_CHART_SP_MODAL_VISIBLE = "REDUX_CHART_SP_MODAL_VISIBLE"
export const REDUX_CHART_CHANGE_SP_MODAL_SYMBOL =
  "REDUX_CHART_CHANGE_SP_MODAL_SYMBOL"

/************************************
 * ACTIONS
 ************************************/
export const chartInitialize = (
  canvasId: string,
  chartType: string,
  data: object = {}
) => {
  const elements = document.querySelector("html").className.split(" ")
  const _initalStatePropety =
    chartType === "tech"
      ? { ...initialStatePropety, ...data }
      : chartType === "mini"
      ? miniChartInitialStatePropety
      : chartType === "external"
      ? externalChartInitialStatePropety
      : spChartInitialStatePropety
  const _chartColor =
    chartType === "tech" && _.includes(elements, "dark")
      ? UserStorage.TechChartColor.getDark()
      : chartType === "tech" && _.includes(elements, "bright")
      ? UserStorage.TechChartColor.getWhite()
      : UserStorage.ChartColor.get()
  const _chartSetting = UserStorage.ChartSetting.get()

  return {
    type: REDUX_CHART_INITIALIZE,
    data: {
      canvasId,
      colorSetting: _chartColor || chartColor.initialize(),
      chartSetting: _chartSetting || chart.defaultChartTechnicalSettings,
      defaultFigureOptions: FIGURE_OPTIONS_DEFAULT_SETTINGS,
      data: _initalStatePropety,
    },
  }
}
export const chartColorSetting = (colorSetting: object) => {
  return {
    type: REDUX_CHART_COLOR_SETTING,
    data: colorSetting,
  }
}

export const changeChartSetting = (chartSetting: object) => {
  return {
    type: REDUX_CHART_SETTING,
    data: chartSetting,
  }
}
export const resetChartSetting = () => {
  const _TechnicalSettings = new TechSetting()
  return {
    type: REDUX_CHART_SETTING,
    data: _TechnicalSettings.TechnicalSettings,
  }
}
export const resetAddonChart = (canvasId: string) => {
  const defaultOptions = new ADDON_CHART_DEFAULT_OPTIONS().defaultOptions
  return {
    type: REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS_RESET,
    data: {
      canvasId,
      data: [
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
      ],
    },
  }
}
export const resetSubChart = (canvasId: string) => {
  const defaultOptions = new SUB_CHART_DEFAULT_OPTIONS().defaultOptions
  return {
    type: REDUX_CHART_CHANGE_SUB_CHART_OPTIONS_RESET,
    data: {
      canvasId,
      data: [
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
        defaultOptions,
      ],
    },
  }
}
export const changeChartDefaultFigureOptions = (
  defaultFigureOptions: object
) => {
  return {
    type: REDUX_CHART_DEFAULT_FIGURE_OPTIONS,
    data: defaultFigureOptions,
  }
}

export const changeProviders = (canvasId: string, providers: Array<any>) => {
  return {
    type: REDUX_CHART_CHANGE_PROVIDERS,
    data: {
      canvasId,
      data: providers,
    },
  }
}

export const changeSymbol = (canvasId: string, symbol: object | null) => {
  const _symbol =
    _.pick(symbol, [
      "Symbol",
      "Exchange",
      "SecurityType",
      "SymbolName",
      "SymbolNameS",
      "NumberOfDecimals",
    ]) || {}
  return {
    type: REDUX_CHART_CHANGE_SYMBOL,
    data: {
      canvasId,
      data: _symbol,
    },
  }
}

export const changeSymbolDetail = (
  canvasId: string,
  symbolDetail: object | null
) => {
  const _symbol = symbolDetail || {}
  return {
    type: REDUX_CHART_CHANGE_SYMBOL_DETAIL,
    data: {
      canvasId,
      data: _symbol,
    },
  }
}

export const changeSubSymbol = (
  canvasId: string,
  symbol: Array<object | null>
) => {
  let _symbol: Array<object> = []
  _.forEach(symbol, items => {
    _symbol.push(
      _.pick(items, [
        "Symbol",
        "Exchange",
        "SecurityType",
        "SymbolName",
        "SymbolNameS",
        "NumberOfDecimals",
        "visible",
      ])
    )
  })
  return {
    type: REDUX_CHART_CHANGE_SUB_SYMBOL,
    data: {
      canvasId,
      data: _symbol,
    },
  }
}

export const changeSubSymbolNode = (
  canvasId: string,
  symbolNode: Array<object | null>
) => {
  return {
    type: REDUX_CHART_CHANGE_SUB_SYMBOL_NODE,
    data: {
      canvasId,
      data: symbolNode,
    },
  }
}

export const changeTools = (
  canvasId: string,
  toolsId: Array<number | null>
) => {
  const _data = pickArray(toolsId, TOOLS)
  return {
    type: REDUX_CHART_CHANGE_TOOLS,
    data: {
      canvasId,
      data: _data,
    },
  }
}
export const changeFigureCommand = (
  canvasId: string,
  figureCommandId: number | null
) => {
  const _figure = pickSingleObj(figureCommandId, FIGURE_COMMAND)
  return {
    type: REDUX_CHART_CHANGE_FIGURE_COMMAND,
    data: {
      canvasId,
      data: _figure,
    },
  }
}

export const changeFigure = (canvasId: string, figureId: number | null) => {
  const _figure = pickSingleObj(figureId, FIGURE)
  return {
    type: REDUX_CHART_CHANGE_FIGURE,
    data: {
      canvasId,
      data: _figure,
    },
  }
}
export const changeFigureType = (
  canvasId: string,
  figureId: number | null,
  figureTypeId: number | null
) => {
  const _figureType = pickSingleObj(figureTypeId, FIGURE[figureId].type)

  return {
    type: REDUX_CHART_CHANGE_FIGURE_TYPE,
    data: {
      canvasId,
      data: _figureType,
    },
  }
}
export const changeFigureOptions = (
  canvasId: string,
  figureId: number | null,
  figureTypeId: number | null,
  figureOptionId: Array<number | null>
) => {
  const _figureOptions = pickArray(
    figureOptionId,
    FIGURE[figureId].type[figureTypeId].options
  )
  return {
    type: REDUX_CHART_CHANGE_FIGURE_OPTIONS,
    data: {
      canvasId,
      data: _figureOptions,
    },
  }
}

export const figureAllClear = (canvasId: string) => {
  return {
    type: REDUX_CHART_CHANGE_FIGURES_ALL_CLEAR,
    data: {
      canvasId,
    },
  }
}

export const changeTerm = (
  canvasId: string,
  termId: number | null,
  priorityTerm?: object
) => {
  const _term = pickSingleObj(termId, priorityTerm || TERM)
  return {
    type: REDUX_CHART_CHANGE_TERM,
    data: {
      canvasId,
      data: _term,
    },
  }
}

export const changeAshiCount = (canvasId: string, ashi: number | null) => {
  const _ashi = ashi || 0
  return {
    type: REDUX_CHART_CHANGE_ASHI_COUNT,
    data: {
      canvasId,
      data: _ashi,
    },
  }
}

export const changeSpan = (canvasId: string, span: object) => {
  return {
    type: REDUX_CHART_CHANGE_SPAN,
    data: {
      canvasId,
      data: span,
    },
  }
}

export const changePlotType = (canvasId: string, plotId: number) => {
  const _plot = pickSingleObj(plotId, PLOTTYPE)
  return {
    type: REDUX_CHART_CHANGE_PLOTTYPE,
    data: {
      canvasId,
      data: _plot,
    },
  }
}

export const changeCycleAnaType = (
  canvasId: string,
  CycleAnaTypes: Array<number | null>
) => {
  const _data = pickArray(CycleAnaTypes, CycleAnaTypesValue)
  return {
    type: REDUX_CHART_CHANGE_CYCLE_ANALYSIS_TYPE,
    data: {
      canvasId,
      data: _data,
    },
  }
}

export const resetCycleAnaType = (canvasId: string) => {
  const _data = new CYCLE_ANALYSIS_TYPE().param
  return {
    type: REDUX_CHART_CHANGE_CYCLE_ANALYSIS_TYPE,
    data: {
      canvasId,
      data: _data,
    },
  }
}

export const changeAddonChart = (
  canvasId: string,
  addonChartId: Array<number | null>,
  termId: number
) => {
  let _addonChartId = addonChartId
  // 念のため5個以上IDがあった時に削除
  if (addonChartId.length > 5) _addonChartId = addonChartId.slice(0, 5)
  const _data = pickArray(_addonChartId, ADDON_CHART)
  return {
    type: REDUX_CHART_CHANGE_ADDON_CHART,
    data: {
      canvasId,
      termId,
      data: _data,
    },
  }
}

export const changeAddonChartOptions = (
  canvasId: string,
  addonChartId: number,
  addonChartOptonsId: Array<number | null>,
  termId: number
) => {
  const _pickData = pickArray(
    addonChartOptonsId,
    ADDON_CHART[addonChartId].options
  )
  return {
    type: REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS,
    data: {
      canvasId,
      addonChartId,
      termId,
      data: _pickData,
    },
  }
}
export const changeSubChart = (
  canvasId: string,
  subChartId: Array<number | null>,
  termId: number
) => {
  let _subChartId = subChartId
  // 念のため4個以上IDがあった時に削除
  if (subChartId.length > 4) _subChartId = subChartId.slice(0, 4)
  const _data = pickArray(_subChartId, SUB_CHART)
  return {
    type: REDUX_CHART_CHANGE_SUB_CHART,
    data: {
      canvasId,
      termId,
      data: _data,
    },
  }
}

export const changeSubChartOptions = (
  canvasId: string,
  subChartId: number,
  subChartOptonsId: Array<number | null>,
  termId: number
) => {
  const _data = pickArray(subChartOptonsId, SUB_CHART[subChartId].options)
  return {
    type: REDUX_CHART_CHANGE_SUB_CHART_OPTIONS,
    data: {
      canvasId,
      subChartId,
      termId,
      data: _data,
    },
  }
}

export const changeChartSize = (canvasId: string, size: chartSize) => {
  return {
    type: REDUX_CHART_CHANGE_SIZE,
    data: {
      canvasId,
      data: size,
    },
  }
}

export const changeRenderCount = (canvasId: string, renderCount: number) => {
  return {
    type: REDUX_CHART_CHANGE_RENDER_COUNT,
    data: {
      canvasId,
      data: renderCount,
    },
  }
}

export const changeTenkankikan = (canvasId: string, tenkanKikan: number) => {
  return {
    type: REDUX_CHART_CHANGE_TENKANKIKAN,
    data: {
      canvasId,
      data: tenkanKikan,
    },
  }
}
export const resetTenkankikan = (canvasId: string) => {
  return {
    type: REDUX_CHART_CHANGE_TENKANKIKAN,
    data: {
      canvasId,
      data: TENKANTEN,
    },
  }
}

export const changePriceVolumeParam = (
  canvasId: string,
  priceVolumeParam: object
) => {
  return {
    type: REDUX_CHART_CHANGE_PRICE_VOLUME_PARAM,
    data: {
      canvasId,
      data: priceVolumeParam,
    },
  }
}

export const resetPriceVolumeParam = (canvasId: string) => {
  const _data = new PRICE_VOLUME_PARAM().param
  return {
    type: REDUX_CHART_CHANGE_PRICE_VOLUME_PARAM,
    data: {
      canvasId,
      data: _data,
    },
  }
}

export const changeDialog = (
  canvasId: string,
  param: Array<(string | object)[]>
) => {
  return {
    type: REDUX_CHART_CHANGE_DIALOG,
    data: {
      canvasId,
      data: param,
    },
  }
}

export const changeDialoPriceVolumeValue = (
  canvasId: string,
  param: object | {}
) => {
  return {
    type: REDUX_CHART_CHANGE_DIALOG_PRICE_VOLUME_VALUE,
    data: {
      canvasId,
      data: param,
    },
  }
}

export const changeChartDate = (canvasId: string, date: Array<Date>) => {
  return {
    type: REDUX_CHART_CHANGE_DATE,
    data: {
      canvasId,
      data: date,
    },
  }
}
export const chartUnmount = (canvasId: string) => {
  return {
    type: REDUX_CHART_UNMOUNT,
    data: {
      canvasId,
    },
  }
}

export const changeRelativeChartFlag = (canvasId: string, flag: boolean) => {
  return {
    type: REDUX_CHART_RELATIVE_CHART_FLAG,
    data: {
      canvasId,
      data: flag,
    },
  }
}

export const changeAddonSelected = (
  canvasId: string,
  selectedItems: Array<number>
) => {
  return {
    type: REDUX_CHART_ADDON_SELECTED,
    data: {
      canvasId,
      data: selectedItems,
    },
  }
}

export const changeSubSelected = (
  canvasId: string,
  selectedItems: Array<number>
) => {
  return {
    type: REDUX_CHART_SUB_SELECTED,
    data: {
      canvasId,
      data: selectedItems,
    },
  }
}

export const changeModalVisible = (visible: boolean) => {
  return {
    type: REDUX_CHART_SP_MODAL_VISIBLE,
    data: {
      canvasId: MODAL_CANVAS_ID,
      data: visible,
    },
  }
}

export const changeSpModalSymbol = (
  symbol: object | null,
  orderBookMode = false,
  industryMode = false,
  subSymbol: object | null = {}
) => {
  const _symbol =
    _.pick(symbol, [
      "Symbol",
      "Exchange",
      "SecurityType",
      "SymbolName",
      "SymbolNameS",
      "NumberOfDecimals",
    ]) || {}
  const _subSymbol =
    _.pick(subSymbol, [
      "Symbol",
      "Exchange",
      "SecurityType",
      "SymbolName",
      "SymbolNameS",
      "NumberOfDecimals",
    ]) || {}
  return {
    type: REDUX_CHART_CHANGE_SP_MODAL_SYMBOL,
    data: {
      canvasId: MODAL_CANVAS_ID,
      visible: true,
      orderBookMode,
      industryMode,
      data: _symbol,
      subData: _subSymbol,
    },
  }
}

// 一括取得関数
export const pickItems = (
  list: any,
  parentId: number,
  typeId: number | null = null,
  optionId: Array<number | null> = []
) => {
  const parentItem = _.pick(list[parentId], pickTarget)
  let type = null
  let option = null

  if (typeId !== undefined || true)
    type = _.pick(list[parentId].type[typeId], pickTarget)
  if (!_.isEmpty(optionId))
    option = _.filter(list[parentId].type[typeId].options, item => {
      return _.includes(optionId, item.id)
    })

  return [parentItem, type, option]
}

export const pickArray = (
  idList: Array<number>,
  targetObj: any
): Array<object | null> => {
  let _targetObj: Array<object | null> = []
  if (_.isEmpty(idList)) return _targetObj

  const _idList = _.uniq(idList)
  _.forEach(_idList, id => {
    _targetObj.push(_.pick(targetObj[id], pickTarget))
  })
  return _targetObj
}

export const pickSingleObj = (
  id: number | null,
  targetObj: any
): object | {} => {
  let _targetObj: object | null = {}

  if (!id && id !== 0) return _targetObj

  _targetObj = _.pick(targetObj[id], pickTarget)

  return _targetObj
}

/************************************
 * REDUCER
 ************************************/
const addonDefaultOptions = new ADDON_CHART_DEFAULT_OPTIONS().defaultOptions
const subChartDefaultOptions = new SUB_CHART_DEFAULT_OPTIONS().defaultOptions
const _priceVolumeParam = new PRICE_VOLUME_PARAM().param
const _cycleAnaTypes = new CYCLE_ANALYSIS_TYPE().param

const initialStatePropety: chartReducerPropety = {
  providers: [],
  symbol: {},
  symbolDetail: {},
  subSymbol: [{}, {}],
  subSymbolNode: [],
  tools: [],
  figureCommand: {},
  figure: {},
  figureType: {},
  figureOptions: [],
  term: TERM[8],
  span: {},
  plotType: PLOTTYPE[0],
  cycleAnaTypes: _cycleAnaTypes,
  addonChart: [[], [], [], [], [], [], [], [], [], [], []],
  addonChartOptions: [
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
    addonDefaultOptions,
  ],
  addonSelected: [],
  subChart: [[], [], [], [], [], [], [], [], [], [], []],
  subChartOptions: [
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
    subChartDefaultOptions,
  ],
  subSelected: [],
  spred: false,
  size: {
    width: 0,
    height: 0,
    scaleWidth: 0,
    scaleHeight: 0,
  },
  renderCount: 300,
  tenkanKikan: TENKANTEN,
  priceVolumeParam: _priceVolumeParam,
  chartInfoDialog: [],
  priceVolumeValue: {},
  date: [new Date(), new Date()],
  relativeChartFlag: false,
}

const miniChartInitialStatePropety: chartReducerPropety = {
  providers: [],
  symbol: {},
  symbolDetail: {},
  term: TERM[8],
  span: {},
  plotType: PLOTTYPE[0],
  size: {
    width: 100,
    height: 200,
    scaleWidth: 200,
    scaleHeight: 400,
  },
  renderCount: 60,
  tenkanKikan: TENKANTEN,
  date: [new Date(), new Date()],
  chartInfoDialog: [],
}

const externalChartInitialStatePropety: chartReducerPropety = {
  providers: [],
  symbol: {},
  symbolDetail: {},
  term: TERM_EXTERNAL[0],
  span: {},
  plotType: PLOTTYPE[0],
  size: {
    width: 100,
    height: 200,
    scaleWidth: 200,
    scaleHeight: 400,
  },
  renderCount: 60,
  tenkanKikan: TENKANTEN,
  date: [new Date(), new Date()],
  chartInfoDialog: [],
}

const spChartInitialStatePropety: chartReducerPropety = {
  providers: [],
  symbol: {},
  symbolDetail: {},
  subSymbol: [{}],
  term: TERM[8],
  span: {},
  plotType: PLOTTYPE[0],
  size: {
    width: 100,
    height: 200,
    scaleWidth: 200,
    scaleHeight: 400,
  },
  renderCount: 60,
  tenkanKikan: TENKANTEN,
  date: [new Date(), new Date()],
  modalVisible: false,
  orderBookMode: false,
  industryMode: false,
}

export default (
  state: chartReducer | {} = {},
  action: { type: string; data?: any }
): chartReducer => {
  let _state: any = {}
  switch (action.type) {
    case REDUX_CHART_INITIALIZE:
      return {
        ...state,
        colorSetting: _state.colorSetting || action.data.colorSetting,
        chartSetting: _state.chartSetting || action.data.chartSetting,
        defaultFigureOptions:
          _state.defaultFigureOptions || action.data.defaultFigureOptions,
        [action.data.canvasId]: action.data.data,
      }
    case REDUX_CHART_COLOR_SETTING:
      return {
        ...state,
        colorSetting: action.data,
      }
    case REDUX_CHART_SETTING:
      return {
        ...state,
        chartSetting: action.data,
      }
    case REDUX_CHART_DEFAULT_FIGURE_OPTIONS:
      return {
        ...state,
        defaultFigureOptions: action.data,
      }
    case REDUX_CHART_CHANGE_PROVIDERS:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          providers: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_SYMBOL:
      _state = _.pick(state, [action.data.canvasId])
      const _symbol = _.get(state, [action.data.canvasId, "symbol"])
      if (_.isEqual(_symbol, action.data.data)) return state
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          symbol: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_SYMBOL_DETAIL:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          symbolDetail: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_SUB_SYMBOL:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          subSymbol: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_SUB_SYMBOL_NODE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          subSymbolNode: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_TOOLS:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          tools: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_FIGURE_COMMAND:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          figureCommand: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_FIGURE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          figure: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_FIGURE_TYPE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          figureType: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_FIGURE_OPTIONS:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          figureOptions: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_FIGURES_ALL_CLEAR:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          figure: {},
          figureType: {},
          figureOptions: [],
        },
      }
    case REDUX_CHART_CHANGE_TERM:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          term: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_ASHI_COUNT:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          ashicount: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_SPAN:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          span: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_PLOTTYPE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          plotType: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_CYCLE_ANALYSIS_TYPE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          cycleAnaTypes: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_ADDON_CHART:
      _state = _.pick(state, [action.data.canvasId])
      _.set(
        state,
        [action.data.canvasId, "addonChart", action.data.termId],
        action.data.data
      )
      return {
        ...state,
      }
    case REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS:
      const addonKey = ADDON_CHART[action.data.addonChartId].key
      _.set(
        state,
        [
          action.data.canvasId,
          "addonChartOptions",
          action.data.termId,
          addonKey,
        ],
        action.data.data
      )

      return {
        ...state,
      }
    case REDUX_CHART_CHANGE_SUB_CHART:
      _.set(
        state,
        [action.data.canvasId, "subChart", action.data.termId],
        action.data.data
      )
      return {
        ...state,
      }
    case REDUX_CHART_CHANGE_SUB_CHART_OPTIONS:
      const subChartKey = SUB_CHART[action.data.subChartId].key
      _.set(
        state,
        [
          action.data.canvasId,
          "subChartOptions",
          action.data.termId,
          subChartKey,
        ],
        action.data.data
      )
      return {
        ...state,
      }
    case REDUX_CHART_CHANGE_SIZE:
      _state = _.pick(state, [action.data.canvasId])
      const { width, height } = action.data.data
      const _width = width ? width : _state[action.data.canvasId].size.width
      const _height = height ? height : _state[action.data.canvasId].size.height
      const scaleWidth = _width * 2
      const scaleHeight = _height * 2
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          size: {
            width: _width,
            height: _height,
            scaleWidth,
            scaleHeight,
          },
        },
      }
    case REDUX_CHART_CHANGE_RENDER_COUNT:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          renderCount: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_TENKANKIKAN:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          tenkanKikan: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_PRICE_VOLUME_PARAM:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          priceVolumeParam: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_DIALOG:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          chartInfoDialog: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_DIALOG_PRICE_VOLUME_VALUE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          priceVolumeValue: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_DATE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          date: action.data.data,
        },
      }
    case REDUX_CHART_UNMOUNT:
      _state = _.pick(state, [action.data.canvasId])
      return _.omit(state, [action.data.canvasId])
    case REDUX_CHART_RELATIVE_CHART_FLAG:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          relativeChartFlag: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_ADDON_CHART_OPTIONS_RESET:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          addonChartOptions: action.data.data,
        },
      }
    case REDUX_CHART_CHANGE_SUB_CHART_OPTIONS_RESET:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          subChartOptions: action.data.data,
        },
      }
    case REDUX_CHART_ADDON_SELECTED:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          addonSelected: action.data.data,
        },
      }
    case REDUX_CHART_SUB_SELECTED:
      const _data = [...action.data.data]
      if (_.includes(_data, SUB_CHART[19].id)) {
        _.set(state, [action.data.canvasId, "spred"], true)
        _.pull(_data, SUB_CHART[19].id)
      } else {
        _.set(state, [action.data.canvasId, "spred"], false)
      }
      _.set(state, [action.data.canvasId, "subSelected"], _data)
      return { ...state }

    case REDUX_CHART_SP_MODAL_VISIBLE:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          modalVisible: action.data.data,
        },
      }

    case REDUX_CHART_CHANGE_SP_MODAL_SYMBOL:
      _state = _.pick(state, [action.data.canvasId])
      return {
        ...state,
        [action.data.canvasId]: {
          ..._state[action.data.canvasId],
          symbol: action.data.data,
          subSymbol: action.data.subData,
          modalVisible: action.data.visible,
          orderBookMode: action.data.orderBookMode,
          industryMode: action.data.industryMode,
        },
      }
    default:
      return state
  }
}
